import { makeObservable, observable } from 'mobx'

class LicenceAllocation {
    id

    @observable groupId

    @observable productId

    @observable feature

    @observable licenceExcempt

    @observable licenceExcemptReason

    constructor({
        id,
        groupId,
        productId,
        feature = [],
        licenceExcempt = false,
        licenceExcemptReason,
    }) {
        this.id = id
        this.groupId = groupId
        this.productId = productId
        this.feature = feature
        this.licenceExcempt = licenceExcempt
        this.licenceExcemptReason = licenceExcemptReason

        makeObservable(this)
    }

    toJSON() {
        return {
            id: this.id,
            groupId: this.groupId,
            productId: this.productId,
            feature: this.feature,
            licenceExcempt: this.licenceExcempt,
            licenceExcemptReason: this.licenceExcemptReason,
        }
    }
}

export default LicenceAllocation
